export const GET_INSA_ENGINE_DATA_START="GET_INSA_ENGINE_DATA_START"
export const GET_INSA_ENGINE_DATA_SUCCESS="GET_INSA_ENGINE_DATA_SUCCESS"
export const GET_INSA_ENGINE_DATA_FAILED="GET_INSA_ENGINE_DATA_FAILED"

export const GET_INSA_ENGINE_DATA_BY_SEARCH_START="GET_INSA_ENGINE_DATA_BY_SEARCH_START"
export const GET_INSA_ENGINE_DATA_BY_SEARCH_SUCCESS="GET_INSA_ENGINE_DATA_BY_SEARCH_SUCCESS"
export const GET_INSA_ENGINE_DATA_BY_SEARCH_FAILED="GET_INSA_ENGINE_DATA_BY_SEARCH_FAILED"